import { QueryString, objectToUrlQuery, toFixed } from '../functions';
import Swal from 'sweetalert2';

$(document).ready(function() {
    const order = {
        isLoadingOrder: false,
        init() {
            $(document).on('click', '#person-type', this, this.selectPersonType);
            $(document).on('click', '.billing-company', this, this.selectBillingCompany);
            $(document).on('click', '.payment-method-input', this, this.selectPaymentMethod);
			$(document).on('click', '#add-new-billing-company', this, this.addNewCompanyModal);
			$(document).on('click', '#search-calendar-trigger', this, this.showCalendar);
            $(document).on('click', '.close-calendar', this, this.closeCalendar);

			$('.order-payment-wrapper .form-check').click(function(){
		        $('.order-payment-wrapper .form-check').removeClass("selected");
		        $('.order-payment-wrapper .form-check-input').prop('checked', false);
		        $(this).addClass("selected");
		        $(this).find(".form-check-input").prop('checked', true);
		    });

			$(document).on('change', '#create-account', function() {
				if ($('#create-account').is(":checked")) {
					$('#passwords-wrapper').show();
				} else {
					$('#passwords-wrapper').hide();
				}
			});

			var obj = this;
			$(document).on('click', '.send-order-btn', function() {
				if (obj.isLoadingOrder) {
					return false;
				}
				
				obj.isLoadingOrder = true;
				$(this).find('i').show();

				$('#order-form').submit();
			});

			$(document).on('click', '.change-car-options', function(e) {
				var parameters = QueryString(null);

				var url = objectToUrlQuery(parameters);
				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#pickup_location', function() {
				var parameters = QueryString(null);

				if ($('#pickup_location option:selected').val() != '') {
					parameters.pl = $('#pickup_location option:selected').val();
				} else {
					delete parameters.pl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = reservationRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#return_location', function() {
				var parameters = QueryString(null);

				if ($('#return_location option:selected').val() != '') {
					parameters.rl = $('#return_location option:selected').val();
				} else {
					delete parameters.rl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = reservationRoute + (url != '' ? '?' + url : '');
			});
        },
		selectPersonType(event) {
			const _this = event.data;

			if ($('#person-type').is(':checked')) {
				$('.company-content').show();
				$('.custom-select').select2({
			        // theme: "classic"
			    });
			} else {
				$('.company-content').hide();
			}
		},
		selectBillingCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if(!id) { return false; }

			$('.billing-company').find('.radio-box').removeClass('selected');
			$(this).find('.radio-box').addClass('selected');

			$('#billing_company').val(id);
		},
		selectPaymentMethod(event) {
			const _this = event.data;

			let total = mainTotal;

			$('.payment-method-input').removeClass('active');
			$(this).addClass('active');

			$('#payment-method').val($(this).data('value'));

			if($(this).data('has-discount') == '1' && $(this).data('discount-value') > 0) {
				total = 1*total - 1*$(this).data('discount-value');

				var html = `
					<li class="fw-bold d-flex align-items-center">
						<i class="fas fa-check me-2"></i>  ${$(this).data('label-discount')}</span>
						<span class="ms-auto">${$(this).data('discount-value')}&euro; (${$(this).data('discount')}%)</span>
					</li>`;
				$('#payment-method-discount-wrapper').html(html);
			} else {
				$('#payment-method-discount-wrapper').html('');
			}

			$('#total').html(toFixed(total,2));
		},
		addNewCompanyModal(event) {
			const _this = event.data;

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/company?source=reservation-page`,
				success: function(response, xhr) {
                    $('#billing-company-modal').html(response);
                    $('#billing-company-modal').modal('show');
                },
                error(error) {
                    console.log(error);
                },
			});
		},
		closeCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			let type = $(this).data('type');
			if (type == '1') {
				if ($('#date-from').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#date-from').data('alert')
					});
		            return false;
		        }
		        if ($('#date-to').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#date-to').data('alert')
					});
		            return false;
		        }
		        if ($('#from-time option:selected').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#from-time').data('alert')
					});
		            return false;
		        }
		        if ($('#to-time option:selected').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#to-time').data('alert')
					});
		            return false;
		        }

				let parameters = QueryString(null);

				parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
				parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

				var url = objectToUrlQuery(parameters);
				window.location = reservationRoute + (url != '' ? '?' + url : '');

				return;
			}

			var drp = $('#calendar-place').data('daterangepicker');
			drp.setStartDate(moment(pickupDate));
			drp.setEndDate(moment(returnDate));
			drp.updateView();

			$('#date-from').val(moment(pickupDate).format('DD/MM/YYYY'));
			$('#date-to').val(moment(returnDate).format('DD/MM/YYYY'));
			$('#date-from-text').html(moment(pickupDate).format('dddd, D MMM'));
			$('#date-to-text').html(moment(returnDate).format('dddd, D MMM'));

			$('#from-time').val(fromTime);
			$('#to-time').val(toTime);

			$('#calendar-wrapper').addClass('visually-hidden');
        	window.scrollTo(0, 0);
		},
		showCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			$('#calendar-wrapper').removeClass('visually-hidden');
        	$('.daterangepicker').css("display", "block");
		},
    };

    if ($('.order-page').length) {
        order.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/reservation.js